import angular from 'angular';

angular.module('cloudX').directive('cxPostAddressForm', [
  '$q',
  'optionsSvc',
  function($q, optionsSvc) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        onbeforesave: '&',
        onaftersave: '&',
        oncancel: '&',
        isRequired: '=?required',
        iClass: '@?',
        labelSeparator: '=?',
        labelHideCountry: '@?',
        hideStreet2: '@?',
        hideButtons: '@?',
        disabled: '=?',
        id: '@',
      },
      template:
        '<div class="addressForm">' +
        '<span ng-show="disabled" ng-bind-html="address | postAddress:labelSeparator:labelHideCountry"></span>' +
        '<a ng-show="isXeditable && !isFormOpen && !disabled" ng-click="isFormOpen=true" class="editable"><span ng-show="address && address.street1" ng-bind-html="address | postAddress:labelSeparator:labelHideCountry | sanitize"></span><i class="glyphicon glyphicon-pencil" ng-show="!address || !address.street1"></i></a> ' +
        '<form name="addressForm" form-key-commands ng-cancel="undo()" ng-submit="save()" ng-show="isFormOpen" autocomplete="false">' +
        '<table>' +
        '<tr>' +
        '<td colspan="2"><input id="{{id}}-Street1Field" type="text" name="street1" class="form-control {{iClass}}" data-1p-ignore ng-model="address.street1" placeholder="{{\'Street\' | translate}}" ng-required="isRequired" ng-class="{\'markedError\':showValidation && addressForm.street1.$invalid}" autocomplete="off" autocorrect="off" spellcheck="false" cx-focus-this="!address.street1"/></td>' +
        '<td><input id="{{id}}-NumberField" type="text" name="number" class="form-control {{iClass}}" data-1p-ignore ng-model="address.number" size="5" maxlength="10" placeholder="{{\'No.\' | translate}}" ng-required="isRequired" ng-class="{\'markedError\':showValidation && addressForm.number.$invalid}" autocomplete="off" autocorrect="off" spellcheck="false"/></td>' +
        '<td><input id="{{id}}-BoxField" type="text" name="box" class="form-control {{iClass}}" data-1p-ignore ng-model="address.box" size="10" maxlength="10" placeholder="{{\'Box\' | translate}}" ng-class="{\'markedError\':showValidation && addressForm.box.$invalid}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" /></td>' +
        '</tr>' +
        '<tr ng-hide="hideStreet2">' +
        '<td colspan="4"><input id="{{id}}-Street2Field" type="text" name="street2" class="form-control {{iClass}}" data-1p-ignore ng-model="address.street2" maxlength="125" placeholder="{{\'Street 2\' | translate}}" ng-class="{\'markedError\':showValidation && addressForm.street2.$invalid}" autocomplete="off" autocorrect="off" spellcheck="false"/></td>' +
        '</tr>' +
        '<tr>' +
        '<td><input id="{{id}}-POCodeField" type="text" name="zipCode" class="form-control {{iClass}}" data-1p-ignore ng-model="address.zipCode" maxlength="15" ng-model-options="{updateOn: \'default blur\', debounce: { \'default\': 100, \'blur\': 0 }}" ng-required="isRequired" placeholder="{{\'Zip\' | translate}}" uib-typeahead="item.code as item.label for item in zipcodes | filter:{code:$viewValue} | limitTo:address.country === \'BE\' ? 25 : 0" typeahead-min-length="3" typeahead-on-select="zipcodeChanged(0,$item)" ng-class="{\'markedError\':showValidation && addressForm.zipCode.$invalid}" autocomplete="off" autocorrect="off" spellcheck="false"/></td>' +
        '<td colspan="3"><input id="{{id}}-CityField" type="text" name="city" class="form-control {{iClass}}" data-1p-ignore ng-model="address.city" maxlength="125" ng-model-options="{updateOn: \'default blur\', debounce: { \'default\': 100, \'blur\': 0 }}" ng-required="isRequired" placeholder="{{\'City\' | translate}}"  uib-typeahead="item.name as item.label for item in zipcodes | filter:{name:$viewValue} | limitTo:address.country === \'BE\' ? 25 : 0" typeahead-min-length="3" typeahead-on-select="zipcodeChanged(1,$item)" ng-class="{\'markedError\':showValidation && addressForm.city.$invalid}" autocomplete="off" autocorrect="off" spellcheck="false"/></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="4"><cx-country-typeahead id="{{id}}-CountryDropDown" name="country" ng-model="address.country" ng-required="isRequired" ng-class="{\'markedError\':showValidation && addressForm.country.$invalid}"></cx-country-typeahead></td>' +
        '</tr>' +
        '<tr ng-hide="hideButtons">' +
        '<td colspan="4" class="buttons">' +
        '<button id="{{id}}-SaveButton" type="submit" class="btn btn-inverse btn-sm" ng-disabled="saving || ($parent.showValidation && addressForm.$invalid)" ng-mouseover="$parent.showValidation=true;"> <i class="glyphicon glyphicon-floppy-disk margin5R" ng-if="!saving"></i><i class="fa fa-spinner fa-spin margin5R" ng-if="saving"></i><span data-translate>Save</span></button>' +
        '<button id="{{id}}-CancelButton" type="button" class="btn btn-default btn-sm" ng-click="undo()" data-translate>Cancel</button>' +
        '</td>' +
        '</tr>' +
        '</table>' +
        '</form>' +
        '</div>',
      require: ['ngModel'],
      link: function($scope, element, attrs, ctrl) {
        var ngModel = ctrl[0];
        $scope.showValidation = false;
        $scope.saving = false;

        $scope.isXeditable = (attrs.xeditable || false) == 'true';
        $scope.isFormOpen = !$scope.isXeditable;

        $scope.zipcodes = optionsSvc.getOptions('zipCodes');
        $scope.zipcodeChanged = function(field, $item) {
          if (!$item || !$item.code || !$item.name) return;
          if (field === 0) $scope.address.city = $item.name;
          if (field === 1) $scope.address.zipCode = $item.code;
        };

        $scope.save = function() {
          if ($scope.addressForm.$invalid) return false;
          console.log($scope.saving);
          $scope.saving = true;
          return $q
            .when(
              $scope.onbeforesave({
                $data: $scope.address,
              }),
            )
            .then(function(result) {
              $scope.saving = false;
              if (typeof result === 'undefined' || result == 'true') {
                ngModel.$setViewValue($scope.address);
                if ($scope.isXeditable) $scope.isFormOpen = false;
                $scope.onaftersave({
                  $data: $scope.address,
                });
                return;
              }

              if (result != 'true') {
                if ($scope.isXeditable) $scope.isFormOpen = false;
                $scope.onaftersave({
                  $data: $scope.address,
                });
              }
            });
        };

        $scope.undo = function() {
          ngModel.$rollbackViewValue();
          if ($scope.isXeditable) $scope.isFormOpen = false;
          $scope.oncancel();
        };

        ngModel.$render = function() {
          // no save button: parent is responsible for saving
          if ($scope.hideButtons) {
            $scope.address = ngModel.$viewValue;
          } else {
            $scope.address = angular.copy(ngModel.$viewValue);
          }
        };
      },
    };
  },
]);
